import { render } from "./learnerCentralLo.vue?vue&type=template&id=6a45b5ce&scoped=true"
import script from "./learnerCentralLo.vue?vue&type=script&lang=js"
export * from "./learnerCentralLo.vue?vue&type=script&lang=js"

import "./learnerCentralLo.vue?vue&type=style&index=0&id=6a45b5ce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a45b5ce"]])

export default __exports__